import { apiSlice } from './apiSlice';
import { AGENCY_URL } from '../constants';

export const agencyApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createAgency: builder.mutation({
      query: (data) => ({
        url: AGENCY_URL,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Agency'],
    }),
    
    updateAgency: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `${AGENCY_URL}/${id}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['Agency'],
    }),
    
    getAgencies: builder.query({
      query: (params) => {
        // Build query string from params
        const queryParams = new URLSearchParams();
        if (params?.isApproved !== undefined) {
          queryParams.append('isApproved', params.isApproved);
        }
        if (params?.isActive !== undefined) {
          queryParams.append('isActive', params.isActive);
        }
        if (params?.agencyTier) {
          queryParams.append('agencyTier', params.agencyTier);
        }
        
        const queryString = queryParams.toString();
        return {
          url: queryString ? `${AGENCY_URL}?${queryString}` : AGENCY_URL,
        };
      },
      providesTags: ['Agency'],
    }),
    
    getAgencyById: builder.query({
      query: (id) => `${AGENCY_URL}/${id}`,
      providesTags: (result, error, id) => [{ type: 'Agency', id }],
    }),
    
    // Add this new mutation for assigning agency to shift
    assignAgencyToShift: builder.mutation({
      query: (data) => ({
        url: `/api/shifts/${data.shiftId}/assign-agency`, // This will need a backend route
        method: 'PUT',
        body: {
          agencyId: data.agencyData.agencyId,
          agencyName: data.agencyData.agencyName,
          agencyEmail: data.agencyData.agencyEmail,
          workerName: data.agencyData.workerName,
          workerContact: data.agencyData.workerContact,
          workerEmail: data.agencyData.workerEmail,
          managerId: data.agencyData.managerId
        },
      }),
      invalidatesTags: ['Shift'], // Make sure you have Shift tags defined in your apiSlice
    }),
  }),
});

export const {
  useCreateAgencyMutation,
  useUpdateAgencyMutation,
  useGetAgenciesQuery,
  useGetAgencyByIdQuery,
  useAssignAgencyToShiftMutation, // Export the new mutation
} = agencyApiSlice;




